import React from "react";

const FreeCashBillingLine = ({ amount, className = "flex justify-between mb-2.5 text-gray-700", labelClass = "font-medium", valueClass = "text-purple-600 font-semibold" }) => {
    if (!amount || Number(amount) <= 0) return null;

    return (
        <div className={className}>
            <span className={labelClass}>Free Cash</span>
            <span className={valueClass}>-₹{Number(amount).toFixed(2)}</span>
        </div>
    );
};

export default FreeCashBillingLine;
